import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import Navbar from './Navbar';

const schema: JSONSchema7 = {
    title: 'Navbar',
    type: 'object',
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        sections: {
            type: 'array',
            title: 'Add sections',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        title: 'Section Id',
                        description: 'Id for section where scroll should happen',
                    },
                    type: {
                        type: 'string',
                        title: 'Select item type',
                        enum: ['Label', 'Icon'],
                        default: 'Label',
                    },
                    ariaLabel: {
                        type: 'string',
                        title: 'Aria Label text',
                    },
                },
                dependencies: {
                    type: {
                        oneOf: [
                            {
                                properties: {
                                    type: { enum: ['Label'] },
                                    label: {
                                        type: 'string',
                                        title: 'Nav Item Label',
                                        default: '',
                                    },
                                },
                            },
                            {
                                properties: {
                                    type: { enum: ['Icon'] },
                                    icon: {
                                        type: 'string',
                                        title: 'Nav Item Icon Name',
                                        default: '',
                                    },
                                },
                            },
                        ],
                    },
                },
            },
        },
        scrollOptions: {
            type: 'string',
            title: 'Scroll Options',
            description: 'Add options for react-scroll',
            default: '',
        },
        isResponsive: {
            type: 'boolean',
            enum: [true, false],
            default: false,
            title: 'Responsive Menu',
        },
        transformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
    },
    dependencies: {
        isResponsive: {
            oneOf: [
                {
                    properties: {
                        isResponsive: { enum: [true] },
                        menuShowIcon: {
                            type: 'string',
                            title: 'Responsive Menu Show Icon',
                            default: 'fas fa-bars',
                        },
                        menuCancelIcon: {
                            type: 'string',
                            title: 'Responsive Menu Cancel Icon',
                            default: 'fas fa-times',
                        },
                    },
                },
                {
                    properties: {
                        isResponsive: { enum: [false] },
                    },
                },
            ],
        },
        transformData: {
            oneOf: [
                {
                    properties: {
                        transformData: { enum: [true] },
                        functionToTransformData: {
                            type: 'string',
                            description: 'Function to transform Data',
                            default: 'return (data) => { return hideSections, widget }',
                        },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['sections', 'scrollOptions', 'isResponsive', 'menuShowIcon', 'menuCancelIcon'],
        'Transform Data': ['transformData', 'functionToTransformData'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    styles: {
        'ui:widget': 'CSSEditor',
    },
    scrollOptions: {
        'ui:widget': 'CustomTextInput',
    },
    isResponsive: {
        'ui:widget': 'CustomCheckbox',
    },
    menuShowIcon: {
        'ui:widget': 'CustomTextInput',
    },
    menuCancelIcon: {
        'ui:widget': 'CustomTextInput',
    },
    functionToTransformData: { 'ui:widget': 'JSEditor' },
    transformData: { 'ui:widget': 'CustomCheckbox' },
    sections: {
        items: {
            'ui:field': 'CollapsibleFieldTemplate',
            id: {
                'ui:widget': 'CustomTextInput',
            },
            ariaLabel: {
                'ui:widget': 'CustomTextInput',
            },
            type: {
                'ui:widget': 'CustomSelect',
            },
            label: {
                'ui:widget': 'CustomTextInput',
            },
            icon: {
                'ui:widget': 'CustomTextInput',
            },
        },
    },
};

const NavbarWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: Navbar,
    id: 'Navbar',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({
        sections: [
            { id: 'section1', label: 'Section 1', type: 'Label' },
            { id: 'section2', label: 'Section 2', type: 'Label' },
            { id: 'section3', label: 'Section 3', type: 'Label' },
        ],
    }),
};

export default NavbarWidget;
